module.exports = __webpack_public_path__ + "img/CGK-logo-horiz-farbig.15cb4c17.png";